import { API } from ".";
import type {
  LoginParams,
  LoginResponse,
  LoginThirdPartyParams,
} from "./auth.type";
import type { DataWrapper } from "./index.type";

export function loginAPI(params: LoginParams) {
  return API.post<DataWrapper<LoginResponse>>("api/v1/users/sign-in", {
    json: params,
  }).json();
}

export function loginThirdPartyAPI(params: LoginThirdPartyParams) {
  return API.post<{ data: LoginResponse }>("api/v1/users/sign-in/third-party", {
    json: params,
  }).json();
}

export function getUserInfoAPI() {
  return API.get<DataWrapper<LoginResponse>>("api/v1/users/info").json();
}
